<template>
    <div class="hot-question-wrap">
        <div v-for="(item, idx) in data" :key="idx">
            <ul class="hot-question-list">
                <li class="list-item" v-for="(question, index) in item.question" :key="index">{{ question.displayText }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: "HotQuestionShape",
    props: ["data"]
};
</script>

<style lang="scss" scoped>
.hot-question-wrap {
    display: inline-block;
    margin-bottom: 10px;
    .hot-question-list {
        float: right;
        display: inline-block;
        width: 300px;
        box-sizing: border-box;
        border-radius: 4px;
        border: 1px solid #d8e4f0;
        font-size: 12px;
        color: #9b9ba3;
        padding: 0 16px;
        background: #fafbfd;
        .list-item {
            padding: 6px 0;
            border-bottom: 1px solid #d8e4f0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        :last-child {
            border-bottom: 0;
        }
    }
}
</style>
